// The WebdriverIO `tvlabs: executeWorkflow` example shown in the editor's CLI
// modal: a background run polled until it finishes (the default), or a
// foreground call that waits for the run.

export const POLL_INTERVAL_SECONDS = 10;

// `keyValues` is a list of `{ name, value }`, in the order they are shown.
export function workflowSnippet({ workflowId, keyValues = [], wait = false }) {
  const args = [`workflowId: ${json(workflowId)}`];
  if (keyValues.length > 0) args.push(`keyValues: ${jsObject(keyValues)}`);

  if (wait) {
    args.push("waitForComplete: true");

    return `const result = await driver.execute("tvlabs: executeWorkflow", {
${indent(args)}
});
// result.status is "completed", "failed" or "interrupted"`;
  }

  return `const { runId } = await driver.execute("tvlabs: executeWorkflow", {
${indent(args)}
});

const run = await driver.waitUntil(
  async () => {
    const current = await driver.execute("tvlabs: getWorkflowRun", { runId });
    return current.status !== "running" && current;
  },
  { interval: ${POLL_INTERVAL_SECONDS * 1000}, timeout: 30 * 60 * 1000 },
);
// run.status is "completed", "failed" or "interrupted"`;
}

function indent(lines) {
  return lines.map((line, i) => "  " + line + (i < lines.length - 1 ? "," : "")).join("\n");
}

function json(value) {
  return JSON.stringify(value ?? null);
}

function jsObject(keyValues) {
  return `{ ${keyValues.map(({ name, value }) => `${json(name)}: ${json(value)}`).join(", ")} }`;
}
